import { Dayjs } from "dayjs";

export interface PaymentReminder {
    type: PaymentReminderType;
    dueAt: Dayjs | number;
    amount?: number;
    lastChargeAttemptedAt?: Dayjs;
    arrivalOffset?: number;
    autoCharge?: boolean;
    chargeAttemptCount?: number;
    comment?: string;
    tag?: string;
    status?: PaymentReminderStatus | undefined;
}

export enum PaymentReminderType {
    SELLER_DEPOSIT = "deposit_seller",
    INVOICE_SELLER = "invoice_seller",
    INVOICE_TRAVELER = "invoice_traveler",
    BALANCE_DUE_TRAVELER = "balance_due_traveler",
}

export enum PaymentReminderStatus {
    IGNORE = "ignore",
    ACTIVE = "active",
}
